<!-- <div *ngIf="item$ | async as item">
    <pre>{{ item | json }}</pre>
    <h1>{{ item.title }}</h1>
    <p>Date: {{ item.date }}</p>
    <img [src]="item.image" alt="image" />
    <p>{{ item.description }}</p>
</div> -->

<app-navbar></app-navbar>

<section class="blog-details-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-md-12">
                <div class="card bgImage text-center" style="padding: 20px; border: 1px solid #eeeeee; margin-top: 15px; margin-bottom: 15px;">
                    <div class="card-body" *ngIf="item$ | async as item">
                        <div class="article-image">
                            <h2 class="text-uppercase">{{ category }}</h2>
                            <img [src]="item.image" alt="image" class="img-fluid mx-auto d-block" style="height: 250px; width: 350px;">
                        </div>
                        <div class="article-content mt-4" style='text-align: justify;'>
                            <h2>{{ item.title }}</h2>
                            <p>{{ item.description }}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-12">
                <aside class="widget-area" id="secondary">

                    <section class="widget widget_karlson_posts_thumb"
                        style="padding: 20px; padding-top: 0; border: 1px solid #eeeeee;">

                        <div class="page-title-content" style="margin-top: 0; text-align: left;">
                            <ul>
                                <li> <a routerLink="/">
                                        <i class="fa-solid fa-house"></i>
                                    </a></li>
                                <li>Administration</li>
                                <li>Message Chairman</li>
                            </ul>
                        </div>
                    </section>

                    <section class="widget widget_karlson_posts_thumb"
                        style="padding: 20px; border: 1px solid #eeeeee; margin-top: 15px;">
                        <h3 class="widget-title">Suggested Video</h3>

                        <iframe width="100%" height="200" src="https://www.youtube.com/embed/Ib3dYDqVqvE"
                            frameborder="0"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen=""></iframe>
                    </section>

                    <section class="widget widget_categories"
                        style="padding: 20px; border: 1px solid #eeeeee; margin-top: 15px;">
                        <h3 class="widget-title">Related Topics</h3>
                        <ul>
                            <li><a routerLink="/chairman-message">Message Chairman</a></li>
                            <li><a routerLink="/under-construction">Governing Body</a></li>
                            <li><a routerLink="/under-construction">Student Advisor</a></li>
                        </ul>
                    </section>
                </aside>
            </div>
        </div>
    </div>
</section>